export const highlight = (keyword, string) => {
    let regex = new RegExp(keyword, 'gi');

    let str = String(string || '').replace(regex, str => {
        return '<b style="color: #0088ff">' + str + '</b>';
    });

    return str;
}